
<template>
  <fullscreen-overlay-frame :title="$t('device-link-dialog.title').toString()"
                            icon="control_point_duplicate"
                            :color="color"
                            centered
                            closable
                            @close="close">

    <template v-slot:content>

      <v-text-field
          class="linkingCode"
          v-model="linkingCode"
          :label="$t('device-link-dialog.code.label')"
          v-mask="'### ### ###'"
          placeholder="123 456 789"
          outlined
          :disabled="external"
      ></v-text-field>

      <v-row class="ma-3" v-if="!inProcess && !external">{{$t('device-link-dialog.qrcode.hint')}}</v-row>
      <br />
      <v-row class="ma-3 flex-column align-center" v-if="inProcess">
        <v-progress-circular color="primary" indeterminate class="mb-3"/>
        {{$t('device-link-dialog.qrcode.in-process')}}
      </v-row>

      <v-btn
        v-if="!external"
        depressed
        large
        :disabled="(linkingCode.length-2) < 9"
        color="primary"
        class="font-weight-bold action-button mt-3"
        @click="startLinking">
        {{$t('device-link-dialog.button.label')}}
      </v-btn>

    </template>
  </fullscreen-overlay-frame>
</template>

<script>
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame";
export default {
  name: 'AddLinkedDeviceDialog',
  components: {
    FullscreenOverlayFrame
  },
  props: ['data'],
  data() {
    return {
      color: 'primary',
      loading: true,
      error: false,
      linkingCode: '',
      inProcess: false,
      pollingHandle: null
    }
  },

  beforeDestroy() {
    this.stopPolling()
  },

  methods: {
    init() {
      if (this.external) {
        this.inProcess = false;
        this.loading = false;
        this.error = false;
        this.linkingCode = this.data.linkingCode.match(/\d{3}/g).join(" ")
        this.startLinking()
      }
    },

    startLinking() {
      var cleanCode = this.linkingCode.replace(/\D/g, '')
      this.loading = true;

      this.$rhRequest.sendPost(
        {
          endpoint: "linked-login/code",
          data: {
            code: cleanCode
          }
        },
        (response) => {
          let result = response.data.data.length < 1;
          if (result) {
            console.error('code cannot memorized')
            this.$root.bisatoast.error({ message: this.$t('app.generic-error') })
            this.loading = false;
            this.error = true;
            this.close();
            return;
          } else {
            this.inProcess = true;
            this.startPolling(cleanCode)
          }
          this.loading = false;
          this.error = false;
        },
        (e) => {
          console.error(e);
          this.loading = false;
          this.error = true;
        }
      );
    },

    startPolling(code) {
      this.stopPolling()
      this.pollingHandle = setInterval(() => {
        this.$rhRequest.sendPost(
          {
            endpoint: "linked-login/find-by-code",
            data: { code: code }
          },
          (response) => {
            const device = response?.data?.data
            this.$root.bisatoast.success({ message: this.$t('device-link-dialog.linked.success') })
            this.close()
            setTimeout(() => {
              this.$root.bisadialog.toggle('editLinkedDevice', true, device)
              this.$root.bisadialog.callDialogInit('editLinkedDevice')
            }, 100)
          },
          () => {
            // 404 or other error - keep polling
          }
        )
      }, 3000)
    },

    stopPolling() {
      if (this.pollingHandle) {
        clearInterval(this.pollingHandle)
        this.pollingHandle = null
      }
    },

    /**
     * close dialog
     */
    close() {
      this.stopPolling()
      this.$root.bisadialog.toggle('addLinkedDevice')
    }
  },

  computed: {
    // true if linkingCode is passed from external
    external() {
      return /^\d{9}$/.test(this.data?.linkingCode ?? '')
    }
  }
}

</script>

<style scoped lang="scss">

.linkingCode :deep(input) {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
}

</style>
